var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"summary"}},[_c('h2',{staticClass:"title is-2"},[_vm._v("Summary Chromosome 6 Questionnaire")]),_c('single',{attrs:{"page":"questionnaire"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }